"use strict";
/*
 * Created on 18. 2. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * {@link MailEvent} converter.
 *
 * @author Radek Beran
 */


var MailEventConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(MailEventConverter, _DataObjectConverter_);

  function MailEventConverter() {
    _classCallCheck(this, MailEventConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MailEventConverter).apply(this, arguments));
  }

  return MailEventConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.MailEventConverter = MailEventConverter;